<div class="dialog">
  <div class="dialog-content">
    <p>{{data.title || ''}}</p>
    <p>{{data.message || ''}}</p>
    <button (click)="onCancel()" class="cancel-button">{{data.btnCancel || 'Cancelar'}}</button>
  </div>
</div>
